"use client";

import { Analytics } from "@vercel/analytics/react";
import { useSession } from "next-auth/react";
import { hasAdminRole } from "@/lib/admin/permissions";

export default function VercelAnalytics() {
  const { data: session, status } = useSession();

  if (status === "loading") {
    return null;
  }

  if (session?.impersonating || hasAdminRole(session)) {
    return null;
  }

  return <Analytics />;
}
